import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const GuestRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const [redirectPath, setRedirectPath] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (loading) return;

    if (!isAuthenticated) {
      setChecking(false);
      return;
    }

    // User is authenticated — determine where to send them
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    (async () => {
      try {
        const orgRes = await axios.get(`${API_URL}/api/organizations`, { headers });
        const hasOrg = orgRes.data && (Array.isArray(orgRes.data) ? orgRes.data.length > 0 : orgRes.data.id);

        if (hasOrg) {
          const creatorsRes = await axios.get(`${API_URL}/api/creators`, { headers });
          if (creatorsRes.data && creatorsRes.data.length > 0) {
            setRedirectPath(`/creator/${creatorsRes.data[0].id}/dashboard`);
          } else {
            setRedirectPath('/create-creator');
          }
        } else {
          setRedirectPath('/create-organization');
        }
      } catch {
        setRedirectPath('/create-organization');
      }
      setChecking(false);
    })();
  }, [isAuthenticated, loading]);

  if (loading || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="w-5 h-5 border-2 border-white/20 border-t-white/60 rounded-full animate-spin" />
      </div>
    );
  }

  if (isAuthenticated && redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default GuestRoute;
